import { render, staticRenderFns } from "./BlockImageRightTextLeft.vue?vue&type=template&id=c848cd64&"
import script from "./BlockImageRightTextLeft.vue?vue&type=script&lang=js&"
export * from "./BlockImageRightTextLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports